import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import {
    ICON_CLASSES, TOOLTIP_CLASSES, FIELD_CLASS, TEXT_CLASS,
    PershingGridInlineMessage, CssClasses, MESSAGE_TYPE
} from '../../models/pershing-grid-inline-message.model';

@Component({
  selector: 'pershing-grid-inline-message',
  templateUrl: './pershing-grid-inline-message.component.html'
})
export class PershingGridInlineMessageComponent implements ICellRendererAngularComp  {
    public inlineMessage: PershingGridInlineMessage = new PershingGridInlineMessage(null);
    public showMessage?: boolean = false;
    public params: any;
    iconClasses: string[] = ICON_CLASSES;
    toolTipClasses: string[] = TOOLTIP_CLASSES;
    fieldClass: string = FIELD_CLASS;
    textClass:  string = TEXT_CLASS;

    agInit(params: any): void {
        this.params = params;
        if ( !params.getInlineMessage ) {
            throw new Error( 'PershingGridInlineMessageComponent required getInlineMessage' +
            '. Refer confluence for more info' );
        }
        this.inlineMessage = params.getInlineMessage( params );
        if ( this.inlineMessage ) {
            this.showMessage = true;
            this.applyStyle( this.inlineMessage.errorType );
        } else {
            this.showMessage = false;
            this.inlineMessage = new PershingGridInlineMessage( params.value );
        }
    }

    refresh(): boolean {
        return false;
    }

    applyStyle(errorType: MESSAGE_TYPE) {
        let cssClasses: CssClasses = this.getStyleForMessage(errorType);
        this.iconClasses = cssClasses.iconClasses;
        this.fieldClass = cssClasses.fieldClass;
        this.toolTipClasses = cssClasses.toolTipClasses;
        this.textClass = cssClasses.textClass;
    }

    getStyleForMessage(changedMessageType: MESSAGE_TYPE): CssClasses {
        let classes: CssClasses = new CssClasses(  );
        let iconClasses: string[];
        let toolTipClasses: string[];
        let fieldClass: string;
        let textClass: string;
        switch ( changedMessageType ) {
            case MESSAGE_TYPE.ERROR:
            iconClasses = ['fa', 'fa-exclamation-circle', 'negative'];
            toolTipClasses = ['mat-tooltip', 'error-state'];
            fieldClass = 'negative';
            textClass = 'negative';
            break;
            case MESSAGE_TYPE.WARNING:
            iconClasses = ['fa', 'fa-exclamation-triangle', 'warning'];
            toolTipClasses = ['mat-tooltip', 'warning-state'];
            fieldClass = 'warning';
            textClass = 'warning';
            break;
            case MESSAGE_TYPE.INFO:
            iconClasses = ['fa', 'fa-info-circle', 'information'];
            toolTipClasses = ['mat-tooltip', 'info-state'];
            fieldClass = 'information';
            textClass = 'information';
            break;
            case MESSAGE_TYPE.SUCCESS:
            iconClasses = ['fa', 'fa-check-circle', 'positive'];
            toolTipClasses = ['mat-tooltip', 'success-state'];
            fieldClass = 'positive';
            textClass = 'positive';
            break;
            default:
            iconClasses = ['fa', 'fa-exclamation-circle', 'negative'];
            toolTipClasses = ['mat-tooltip', 'error-state'];
            fieldClass = 'ag-field-error';
            textClass = 'negative';
        }
        classes.iconClasses = iconClasses;
        classes.toolTipClasses = toolTipClasses;
        classes.fieldClass = fieldClass;
        classes.textClass = textClass;
        return classes;
    }
}
